export const FrequencyOption = [
  {
    label: 'Hourly',
    value: 'hourly',
  },
  {
    label: 'Daily',
    value: 'daily',
  },
  {
    label: 'Weekly',
    value: 'weekly',
  },
  {
    label: 'Yearly',
    value: 'yearly',
  },
]

export const DurationOption = [
  {
    label: 'Day/s',
    value: 'days',
  },
  {
    label: 'Week/s',
    value: 'week',
  },
  {
    label: 'Month/s',
    value: 'month',
  },
  {
    label: 'Year/s',
    value: 'year',
  },
]

export const IngestionInstructionOption = [
  {
    label: 'Before Food',
    value: 'before_food',
  },
  { label: 'After Food', value: 'after_food' },
]

export const TimeOfIngestionOption = [
  {
    label: 'Morning',
    value: 'morning',
  },
  {
    label: 'Afternoon',
    value: 'afternoon',
  },
  {
    label: 'Evening',
    value: 'evening',
  },
  {
    label: 'Bed Time',
    value: 'bed_time',
  },
]

export const SearchType = [
  {
    label: 'Name',
    value: 'name',
  },
  {
    label: 'Mobile',
    value: 'mobile',
  },
]

export const CANCELLATION_REASONS = [
  {
    value: 'PRODUCT_UNAVAILABLE',
    label: 'Product Unavailability',
  },
  { value: 'DOUBLE_ORDER', label: 'Double Order' },
  {
    value: 'URGENT_ORDER',
    label: "Urgent Order; can't be fulfilled same day",
  },
  {
    value: 'HIGHER_DISCOUNT',
    label: 'Need for higher discount',
  },
  {
    value: 'NOT_REGISTERED',
    label: 'Products not registered in Nepal',
  },
  { value: 'MERGE_IN_ONE', label: 'Order Merged in one' },
  { value: 'CUSTOMER_WISH', label: 'Customer wish to cancel' },
  {
    value: 'CALL_NOT_RECEIVED_FOR_LONG',
    label: 'Call not received for long time',
  },
  { value: 'OTHER', label: 'Other' },
]
